/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  LinkViewModel,
  TableModel1TaskGet,
  TaskGet,
  TaskViewModel,
  TasksFilter,
  UpdateCommentBody,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Tasks<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Tasks
   * @name TasksDetail
   * @summary Получить задачу по идентификатору
   * @request GET:/tasks/{id}
   * @secure
   * @response `200` `TaskGet` Задача
   */
  tasksDetail = (id: string, params: RequestParams = {}) =>
    this.request<TaskGet, any>({
      path: `/tasks/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name GetTaskList
   * @summary Возвращает список задач
   * @request POST:/tasks/list
   * @secure
   * @response `200` `TableModel1TaskGet` Список задач
   */
  getTaskList = (data: TasksFilter, params: RequestParams = {}) =>
    this.request<TableModel1TaskGet, any>({
      path: `/tasks/list`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name CreateTask
   * @summary Создание задачи
   * @request POST:/tasks/create
   * @secure
   * @response `200` `void` Success
   */
  createTask = (data: TaskViewModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/tasks/create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name UpdateTask
   * @summary Обновление задачи
   * @request POST:/tasks/{id}/update
   * @secure
   * @response `200` `void` Success
   */
  updateTask = (id: string, data: TaskViewModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/tasks/${id}/update`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name DeleteTask
   * @summary Удаление задачи
   * @request GET:/tasks/{id}/delete
   * @secure
   * @response `200` `void` Success
   */
  deleteTask = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/tasks/${id}/delete`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name GetMyTaskList
   * @summary Возвращает список "моих" задач
   * @request POST:/tasks/myTask
   * @secure
   * @response `200` `TableModel1TaskGet` Список задач
   */
  getMyTaskList = (data: TasksFilter, params: RequestParams = {}) =>
    this.request<TableModel1TaskGet, any>({
      path: `/tasks/myTask`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name UpdateComment
   * @summary Редактирования комментария к задаче
   * @request POST:/tasks/commentUpdate
   * @secure
   * @response `200` `void` Success
   */
  updateComment = (data: UpdateCommentBody, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/tasks/commentUpdate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name DeleteComment
   * @summary Удаление комментария
   * @request GET:/tasks/{id}/commentDelete
   * @secure
   * @response `200` `void` Success
   */
  deleteComment = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/tasks/${id}/commentDelete`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name CreateLink
   * @summary Добавление ссылки
   * @request POST:/tasks/linkCreate
   * @secure
   * @response `200` `void` Success
   */
  createLink = (data: LinkViewModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/tasks/linkCreate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tasks
   * @name DeleteLink
   * @summary Удаление ссылки
   * @request GET:/tasks/{id}/linkDelete
   * @secure
   * @response `200` `void` Success
   */
  deleteLink = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/tasks/${id}/linkDelete`,
      method: "GET",
      secure: true,
      ...params,
    });
}
